import React, { useEffect, useState } from 'react';
import { useTypedTranslation } from '@app/hooks';
import { Link } from '@material-ui/core';
import { basicService } from '@app/services';

export const SetUpDeviceYubikey = () => {
    const { translation } = useTypedTranslation();
    const [yubikeyLink, setYubikeyLink] = useState('');

    useEffect(() => {
        basicService.getYubikeyLink().then(result => setYubikeyLink(result.data));
    }, []);

    return (
        <>
            <div className='manage-mfa-token__part manage-mfa-token__part-1'>
                <span>1. {' '}</span>
                <span>
                    {translation('INSTALL_ON_YUBIKEY_STEP_1')}{' '}
                    <Link href={yubikeyLink} className='manage-mfa-token__link' rel='noopener noreferrer' target='_blank' underline='none'>
                        {translation('DESKTOP_APP_INSTALL_STEP_1_PART_2')}
                    </Link>
                </span>
            </div>
        </>
    );
};
